import { render, staticRenderFns } from "./AtomIcon.vue?vue&type=template&id=163a06b4&scoped=true&"
import script from "./AtomIcon.vue?vue&type=script&lang=js&"
export * from "./AtomIcon.vue?vue&type=script&lang=js&"
import style0 from "./AtomIcon.vue?vue&type=style&index=0&id=163a06b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a06b4",
  null
  
)

export default component.exports